<ng-container *ngIf="!loading; else: spinner">
  <app-user-header [user]="user" />
  <app-user-form [user]="user" [mode]="formModes.update" />
</ng-container>
<ng-template #spinner> <mat-spinner /> </ng-template>
